import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext({ isAdmin: false, setIsAdmin: () => {} });

export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
